import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";

interface DeleteIntegrationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  integrationName?: string;
  loading?: boolean;
}

export default function DeleteIntegrationDialog({
  open,
  onClose,
  onConfirm,
  integrationName,
  loading = false,
}: DeleteIntegrationDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to remove the integration "
          {integrationName || "Unknown Integration"}"?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          This action cannot be undone. You will need to reinstall the
          integration if you want to use it again.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={loading}
        >
          {loading ? (
            <>
              <CircularProgress size={16} sx={{ mr: 1 }} />
              Removing...
            </>
          ) : (
            "Remove Integration"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}